import React from "react";
import { observer, inject } from 'mobx-react';

import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";

import CloseIcon from "@material-ui/icons/CloseRounded";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspaceRounded";

import PackLists from "../components/PackLists";
import ChangeTheme from "../components/ChangeTheme";
import Info from "../components/Info";
import { MenuItem, IconButton } from "@material-ui/core";
import tigerLogo from 'images/tree/tiger-logo-blue.png';


const PackListsMenu = ({ store, handleListItemClick }) => (
  <Box display="flex" flexDirection="column" className="pack_lists_layout_root">
    <Grid
      container
      direction="row"
      justify="space-between"
      alignItems="center"
    >
      <IconButton className="back_button" onClick={() => store.showPacksMenu(true)}>
        <KeyboardBackspaceIcon
          className="back_button_icon"
          aria-haspopup="true"
        />
      </IconButton>

      <IconButton className="close_button" onClick={store.handleMenuClose}>
        <CloseIcon
          className="close_button_icon"
          aria-haspopup="true"
        />
      </IconButton>
    </Grid>

    <h2 className="heading"> <img className="tiger_logo" src={tigerLogo} /> {PACK ? PACK.name : "Main Dashboard"}</h2>
    <Box flexGrow={1}>
      <PackLists onClick={handleListItemClick} store={store} />
      {
        PACK && <MenuItem className="menu_list_item new_tigersheet_button" onClick={(e) => viewPort.headerPanel.showCreateSheetMenu({ target: e.target })}>Add Sheet</MenuItem>
      }
    </Box>
    <Grid container direction="column" className="bottom_nav">
      {
        !window.isLoggedInForFirstTimeSession &&
        <ChangeTheme isDarkTheme={store.isCurrentThemeDark} handleChange={store.setCurrentTheme} />
      }
      <Info />
    </Grid>
  </Box>
);

export default observer(PackListsMenu);